import {createSendRequestParams, getApiRoute, sendRequest} from 'utils';

export const getOfferDetailsRequest = async (payload: string): Promise<any | undefined> => {
    const sendRequestParams = createSendRequestParams<any>(getApiRoute(`offer/${payload}/`));
    return await sendRequest<any>(sendRequestParams);
};
